// extracted by mini-css-extract-plugin
module.exports = {"taskHeader":"TaskHeader_taskHeader__35TWl","buttonSave":"TaskHeader_buttonSave__fXpR0","taskName":"TaskHeader_taskName__tGk5h","taskActions":"TaskHeader_taskActions__3Twhl"};